// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"Search_visuallyHidden__hL1bO"};